import React, { useState, useRef, useEffect } from 'react';

export function OmDrone() {
  const [on, setOn] = useState(false);
  const ref = useRef(null);

  function start() {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return;
    const ctx = new Ctor();
    const master = ctx.createGain();
    master.gain.value = 0;
    master.gain.linearRampToValueAtTime(0.16, ctx.currentTime + 2.5);
    master.connect(ctx.destination);

    const freqs = [110, 165, 220];
    const oscs = freqs.map((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = i === 0 ? "sine" : i === 1 ? "sine" : "triangle";
      o.frequency.value = f;
      o.detune.value = (i - 1) * 4;
      g.gain.value = i === 0 ? 0.55 : i === 1 ? 0.32 : 0.18;
      o.connect(g).connect(master);
      o.start();
      return { o, g };
    });

    const lfo = ctx.createOscillator();
    const lfoGain = ctx.createGain();
    lfo.frequency.value = 0.16;
    lfoGain.gain.value = 0.04;
    lfo.connect(lfoGain).connect(master.gain);
    lfo.start();

    ref.current = { ctx, master, oscs, lfo };
  }

  function stop() {
    const n = ref.current;
    if (!n) return;
    try {
      n.master.gain.cancelScheduledValues(n.ctx.currentTime);
      n.master.gain.linearRampToValueAtTime(0, n.ctx.currentTime + 0.9);
      setTimeout(() => { try { n.ctx.close(); } catch (e) {} }, 1100);
    } catch (e) {}
    ref.current = null;
  }

  useEffect(() => () => stop(), []);

  function toggle() {
    if (on) { stop(); setOn(false); }
    else { start(); setOn(true); }
  }

  return (
    <button className={`om-toggle ${on ? "on" : ""}`} onClick={toggle} aria-pressed={on} aria-label="Toggle Om drone">
      <span className="om-glyph">ॐ</span>
      <span className="om-label">{on ? "drone on" : "drone"}</span>
    </button>
  );
}
